module.exports = __webpack_public_path__ + "static/media/step4@1x.e945cd03.mov";